<template>
  <a v-if="$store.state.isApp" @click="fbLoginModule"  style="color: white;">
    <div class="btn btn-success btn-fb">
      <img src="/img/profile/facebook-white-icon.svg"/>
      <span>
        {{$store.state.fbModuleAlert}}<slot></slot>
      </span>
    </div>
  </a>

  <a v-else href="/api/user/facebook-login" style="color: white;">
    <div class="btn btn-success btn-fb">
      <img src="/img/profile/facebook-white-icon.svg"/>
      <span>
        <slot></slot>
      </span>
    </div>
  </a>
</template>

<script>
import {mapActions} from "vuex";
import FbAlert from "@/components/login/FbAlert";

export default {
  components:{
    FbAlert
  },
  mounted() {
    if (window.location.hash) {
      let t = window.location.hash.split("&")[0];
      let token = t.split("=")[1];

      this.callback_fb_login(token, null);
    }
  },
  methods: {
    ...mapActions({
      fbLogin: "FB_LOGIN",
      getLib: 'GET_LIB',
      getProfile: 'GET_PROFILE',
    }),
    test(){
      //window.open('/api/user/facebook-login', '_system');
      window.open('/api/user/facebook-login', '_blank', 'toolbar=yes');
    },
    fbLoginModule(){
      if(typeof(facebookConnectPlugin) === 'undefined'){
        this.$store.state.fbModuleAlert = true;
        return;
      }
      let self = this;
      facebookConnectPlugin.login(["public_profile",'email'],
          (userData) => {
            this.callback_fb_login(userData.authResponse.accessToken, null);
          },
          function loginError (error) {
            if(error === 'Class not found'){
              self.$store.state.fbModuleAlert = true;
            }
          }
      );
    },
    callback_fb_login(token, link, callback) {
      this.fbLogin({token, link}).then(res => {
        if (res.data.status == "ok") {
          if (!callback) {
            this.$store.state.access_token = res.data.access_token;
            localStorage.setItem('access_token', res.data.access_token);

            this.getProfile();
            let th = this;
            setTimeout(function (){
              th.getProfile();
            },3000);
            //this.getLib(true)
            if (this.$route.path == "/sign-in") {
              this.$router.push("/");
            } else {
              this.$store.state.popup = null;
            }
          } else {
            callback();
          }
        }
      })
          .catch(function () {
          });
    }
    /*fb_login(link, callback) {
      let self = this;

      let fbUrl =
          "https://www.facebook.com/v11.0/dialog/oauth?client_id=268857474012014&redirect_uri=" +
          this.$store.state.baseUrl + "/profiles&scope=email&response_type=token";

      if (this.$store.state.isApp) {

        let win = window.open(fbUrl, '_blank', 'toolbar=yes');
        let th = this;

        win.addEventListener('loadstart', function (e) {
          if (e.url.indexOf('access_token') >= 0) {
            let url = e.url.split("#")[1];
            let arr_url = url.split("&");
            let token = arr_url[0].split("=")[1];
            th.callback_fb_login(token);
            win.close();
          }
        });
      } else {
        FB.getLoginStatus(function(response) {
          if (response.status == "not_authorized") {
            FB.login();
          }


          if (response.status == "unknown") {
            window.location.href = fbUrl;
          }

          if (response.status == "connected") {
            if (response.authResponse) {
              if (response.authResponse.accessToken) {
                self.callback_fb_login(response.authResponse.accessToken, link, callback);
              }
            }
          }
        });
        /*
        FB.login(response => {

              if (response.status == "connected") {
                let token = response.authResponse.accessToken;
                self.callback_fb_login(token, link, callback);
              }
            },
            {scope: "email"}
        );
      }
    },*/
  }
};
</script>
